<template>
  <Transition name="toast">
    <div v-if="toast.visible" class="toast" :class="`toast--${toast.type}`">
      <CheckCircle v-if="toast.type === 'success'" :size="16" class="toast-icon" />
      <AlertCircle v-else-if="toast.type === 'error'" :size="16" class="toast-icon" />
      <Info v-else :size="16" class="toast-icon" />
      <span class="toast-msg">{{ toast.message }}</span>
      <button class="toast-close" @click="toast.visible = false">✕</button>
    </div>
  </Transition>
</template>

<script>
import { CheckCircle, AlertCircle, Info } from 'lucide-vue-next'
import { useToast } from '@/composables/useToast'

export default {
  name: 'ToastNotification',
  components: { CheckCircle, AlertCircle, Info },
  setup() {
    const { toast } = useToast()
    return { toast }
  },
}
</script>

<style scoped>
.toast {
  position: fixed;
  bottom: 28px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 18px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 20px rgba(0,0,0,0.14);
  min-width: 240px;
  max-width: 480px;
  white-space: nowrap;
  pointer-events: all;
}

.toast--success { background: #ecfdf5; color: #065f46; border: 1px solid #6ee7b7; }
.toast--error   { background: #fef2f2; color: #991b1b; border: 1px solid #fca5a5; }
.toast--info    { background: #eff6ff; color: #1e40af; border: 1px solid #93c5fd; }

.toast-icon { flex-shrink: 0; }
.toast-msg  { flex: 1; overflow: hidden; text-overflow: ellipsis; }

.toast-close {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 12px;
  opacity: 0.5;
  padding: 0 2px;
  line-height: 1;
  flex-shrink: 0;
}
.toast-close:hover { opacity: 1; }

.toast-enter-active, .toast-leave-active { transition: opacity 0.22s, transform 0.22s; }
.toast-enter-from  { opacity: 0; transform: translateX(-50%) translateY(12px); }
.toast-leave-to    { opacity: 0; transform: translateX(-50%) translateY(12px); }
</style>
